import { useState } from "react";
import { toast } from "sonner";
import { RETURNS } from "../../data/adminData";
import { fmt } from "../../data/store";
import { PageTitle, Table, Badge, Btn, dt } from "./ui";

const COLOR = { "Gaida lēmumu": "amber", "Apstiprināts": "black", "Atmaksāts": "green", "Noraidīts": "gray" };

export default function Returns() {
  const [list, setList] = useState(RETURNS);
  const act = (id, status, msg) => {
    setList((p) => p.map((r) => (r.id === id ? { ...r, status } : r)));
    toast.success(msg + " (DEMO)");
  };
  return (
    <div data-testid="admin-returns">
      <PageTitle>Atgriešanas / RMA ({list.length})</PageTitle>
      <Table head={["RMA nr.", "Pasūtījums", "Klients", "Prece", "Iemesls", "Summa", "Datums", "Statuss", "Darbības"]} minWidth="900px">
        {list.map((r) => (
          <tr key={r.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`return-row-${r.id}`}>
            <td className="p-3 font-bold">{r.id}</td>
            <td className="text-[#6B6B6B]">{r.order}</td>
            <td>{r.customer}</td>
            <td className="max-w-[180px] truncate">{r.product}</td>
            <td className="text-[#6B6B6B]">{r.reason}</td>
            <td className="font-bold">{fmt(r.refund)}</td>
            <td className="text-[#6B6B6B]">{dt(r.date)}</td>
            <td><Badge color={COLOR[r.status]}>{r.status}</Badge></td>
            <td className="p-3">
              {r.status === "Gaida lēmumu" && (
                <div className="flex gap-1.5">
                  <Btn onClick={() => act(r.id, "Apstiprināts", "Atgriešana apstiprināta")} data-testid={`return-approve-${r.id}`}>Apstiprināt</Btn>
                  <Btn variant="outline" onClick={() => act(r.id, "Noraidīts", "Atgriešana noraidīta")} data-testid={`return-reject-${r.id}`}>Noraidīt</Btn>
                </div>
              )}
              {r.status === "Apstiprināts" && <Btn variant="red" onClick={() => act(r.id, "Atmaksāts", `Atmaksāts ${fmt(r.refund)} — kredītrēķins izveidots`)} data-testid={`return-refund-${r.id}`}>Atmaksāt</Btn>}
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
